import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { Input as AntdInput, InputProps as AntdInputProps, InputRef } from 'antd';
import React from 'react';

export type InputProps<T extends FieldValues> = UseControllerProps<T> &
  AntdInputProps;

export const Input = React.forwardRef<InputRef, InputProps<any>>(({
  name,
  className,
  ...props
}, ref) => {
  const {
    field: { onChange, onBlur, value },
  } = useController({ name });

  return (
    <AntdInput
      ref={ref}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
  );
});

Input.displayName = 'Input';
